import { useQuery } from "@tanstack/react-query";
import { parseApiResponse } from "../models";

export const useCurrencies = (client, token) => {
  return useQuery(
    ["currencies"],
    async () => {
      const res = await client(`configuration/currency/currencies`);
      return parseApiResponse(res).data?.currencies || [];
    },
    {
      enabled: !!token,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err) => {
        console.error("Failed to fetch currencies:", err);
      },
    },
  );
};
